export default __webpack_public_path__ + "static/mens-85da4d63122c6ba68784372094593640.png";